import * as BABYLON from 'babylonjs';
import * as BABYLONGUI from 'babylonjs-gui';
//import PanoViewer = require('./PointViewer');
import ViewerStore from '../../stores/ViewerStore';
import * as Inovx from '@shared';
import ViewerActions from '../../actions/ViewerActions';
import * as Enumerations from '../../Enumerations/Enumerations';
import * as Interfaces from '../../Interfaces/Interfaces';
declare var InovxLoader: any;
interface ICoordinate {
    pointCoordinate: BABYLON.Vector3,
    screenCoordinate: BABYLON.Vector2
}

interface IMeasurement {
    
    text: any,
    valid: boolean,
    startValid:boolean,
    isDirty: boolean,
    lines: BABYLON.Mesh[],
    measureMode: MeasurementType
}
interface ILineInfo extends IMeasurement {
    startPosition: ICoordinate,
    endPosition: ICoordinate,
    textLine: BABYLON.LinesMesh,
    distance:number
}
interface IPointMeasurementInfo extends IMeasurement {
    startPosition: ICoordinate
}

interface IPickingInfo {
    type: Enumerations.PickObjectType;
    info: any;
}

class MeasurementManager implements Interfaces.Interfaces.IMeasurementManager {
    private _measurementCounter = 0;
    private _measureMode: MeasurementType = MeasurementType.Point;
    //private _viewer: PanoViewer;
    private _scene: BABYLON.Scene;
    private _engine: BABYLON.Engine;
    private _rayPickProvider: Interfaces.Interfaces.IRayPickProvider;
    private _guiTexture: BABYLONGUI.AdvancedDynamicTexture;
    private _measurements: IMeasurement[] = [];
    private _currentLine: ILineInfo = null;
    private _validMeasurementColors: BABYLON.Color4[] = [];
    private _invalidMeasurementColors: BABYLON.Color4[] = [];
    private _sphereMeasurementMaterial: BABYLON.ShaderMaterial;
    private _arrowScale = 10;
    private _pointerMoved = false;
    private _validColor: BABYLON.Color3 = new BABYLON.Color3(0, 0, 1);

    //private get viewer() { return this._viewer; }
    private get scene() { return this._scene; }
    private get engine() { return this._engine; }

    constructor(scene: BABYLON.Scene, engine: BABYLON.Engine) {
        this._scene = scene;
        this._engine = engine;
        this._measureMode = null;
        this._guiTexture = BABYLONGUI.AdvancedDynamicTexture.CreateFullscreenUI('UI');

        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        this._invalidMeasurementColors.push(new BABYLON.Color4(1, 0, 0, 1));
        
        // Initialize valid measurement colors using the single configurable _validColor
        for (let i = 0; i < 8; i++) {
            this._validMeasurementColors.push(new BABYLON.Color4(this._validColor.r, this._validColor.g, this._validColor.b, 1));
        }
        
        this.scene.onPointerObservable.add(this._handlePointerObservable);
        this.scene.onBeforeCameraRenderObservable.add(this._handleBeforeCameraRenderObservable);

        const vertexShader = `
        precision highp float;

        attribute vec3 position;
        attribute vec3 normal;
        attribute vec2 uv;

        uniform mat4 worldViewProjection;

        void main(void) {
            gl_Position = worldViewProjection * vec4(position, 1.0);
        }
        `;

        const fragmentShader = `
        precision highp float;

        uniform vec3 color;

        void main(void) {
            gl_FragColor = vec4(color, 1.0);
        }
        `;

        const shaderMaterial = new BABYLON.ShaderMaterial("shader", this.scene, {
            vertex: "custom",
            fragment: "custom",
        }, {
            attributes: ["position"],
            uniforms: ["worldViewProjection", "color"],
        });

        // Define the shaders
        BABYLON.Effect.ShadersStore["customVertexShader"] = vertexShader;
        BABYLON.Effect.ShadersStore["customFragmentShader"] = fragmentShader;

        // Set the color uniform in the shader
        shaderMaterial.setColor3("color", this._validColor); // central valid color
        this._sphereMeasurementMaterial = shaderMaterial;
    }

    public dispose() {
        this._clearLines();

        this.scene.onPointerObservable.removeCallback(this._handlePointerObservable);
        this.scene.onBeforeCameraRenderObservable.removeCallback(this._handleBeforeCameraRenderObservable);
    }

    public setRayPickProvider(rayPickProvider: Interfaces.Interfaces.IRayPickProvider) {
        this._rayPickProvider = rayPickProvider;
    }
    public getMeasurementColor(): string {
        return this._validColor.toHexString();
    }
    public setMeasurementColor(color: string) {
        if (!color)
            return;
        let newColor: BABYLON.Color3;
        try {
            newColor = BABYLON.Color3.FromHexString(color);
        } catch {
            return; // invalid hex string, ignore
        }
        if (this._validColor && newColor.equals(this._validColor))
            return; // no change

        this._validColor = newColor;

        // Rebuild color arrays
        this._validMeasurementColors.length = 0;
        for (let i = 0; i < 8; i++) {
            this._validMeasurementColors.push(new BABYLON.Color4(this._validColor.r, this._validColor.g, this._validColor.b, 1));
        }

        // Update materials / shader
        if (this._sphereMeasurementMaterial) {
            this._sphereMeasurementMaterial.setColor3("color", this._validColor);
        }
    }

    public setMeasurementMode(mode: MeasurementType) {

        if (this._currentLine != null) {
            this._disposeLineData(this._currentLine);

            this._currentLine = null;
        }

        this._measureMode = mode;
    }
    public setMeasurements(measurements: Measurement[]) {

        this._clearLines();

        this._measurementCounter = measurements.length;
        for (var x = 0; x < measurements.length; x++) {
            if (measurements[x].checked) {
                if (measurements[x].measureMode == MeasurementType.Point) {
                    var pointMeasurement = measurements[x] as PointMeasurement;

                    
                    var posInf: ICoordinate = {
                        pointCoordinate: new BABYLON.Vector3(pointMeasurement.startPosition.x, pointMeasurement.startPosition.y, pointMeasurement.startPosition.z), screenCoordinate: null
                    };
                    var point: IPointMeasurementInfo = { startPosition: posInf, text: null, startValid:true, valid: true, lines: [], isDirty: true, measureMode: MeasurementType.Point };

                    var startScreen = BABYLON.Vector3.Project(
                        point.startPosition.pointCoordinate,
                        BABYLON.Matrix.Identity(),
                        this.scene.getTransformMatrix(),
                        this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                    );

                    point.startPosition.screenCoordinate = new BABYLON.Vector2(startScreen.x, startScreen.y);
                    this._measurements.push(point);
                    var startSeen = this.scene.activeCamera.isInFrustum(new BABYLON.BoundingInfo(point.startPosition.pointCoordinate, point.startPosition.pointCoordinate));

                    this._updatePointMeasurement(point, startSeen);
                }
                else {
                    var lineMeasurement = measurements[x] as DistanceMeasurement;

                    var startCoord: ICoordinate = {
                        pointCoordinate: new BABYLON.Vector3(lineMeasurement.startPosition.x, lineMeasurement.startPosition.y, lineMeasurement.startPosition.z), screenCoordinate: null
                    };
                    var endCoord: ICoordinate = {
                        pointCoordinate: new BABYLON.Vector3(lineMeasurement.endPosition.x, lineMeasurement.endPosition.y, lineMeasurement.endPosition.z), screenCoordinate: null
                    };

                    var startScreen = BABYLON.Vector3.Project(
                        startCoord.pointCoordinate,
                        BABYLON.Matrix.Identity(),
                        this.scene.getTransformMatrix(),
                        this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                    );

                    var endScreen = BABYLON.Vector3.Project(
                        endCoord.pointCoordinate,
                        BABYLON.Matrix.Identity(),
                        this.scene.getTransformMatrix(),
                        this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                    );

                    startCoord.screenCoordinate = new BABYLON.Vector2(startScreen.x, startScreen.y)
                    endCoord.screenCoordinate = new BABYLON.Vector2(endScreen.x, endScreen.y)

                    var distance: ILineInfo = { distance: lineMeasurement.distance, startPosition: startCoord, endPosition: endCoord, text: null, startValid:true, valid: true, lines: [], textLine: null, isDirty: true, measureMode: lineMeasurement.measureMode as any };
                    this._measurements.push(distance);

                    this._updateLine(distance, this.scene.activeCamera);
                }
            }
        }
    }
    public clearMeasurements() {
        this._clearLines();
    }
    private _clearLines() {
        this._measurements.forEach(measurement => {
            this._disposeMeasurement(measurement);
        });

        if (this._currentLine != null) {
            this._disposeMeasurement(this._currentLine);
        }
        this._measurements = [];
    }
    
    private async _createMeasurement(measurement: IMeasurement) {
        var jsonMeasurement = measurement.measureMode == MeasurementType.Point ? { name: InovxLoader.t('facility:measurement.coordinate'), measureMode: measurement.measureMode, startPosition: (measurement as any).startPosition.pointCoordinate } : { name: InovxLoader.t('facility:measurement.dimension'), measureMode: measurement.measureMode, startPosition: (measurement as any).startPosition.pointCoordinate, endPosition: (measurement as any).endPosition.pointCoordinate, distance: (measurement as any).distance };

        (jsonMeasurement as any).id = "TRANS_" + this._measurementCounter.toString();
        this._measurementCounter++;

        (jsonMeasurement as any).saved = false;
        (jsonMeasurement as any).dirty = true;
        (jsonMeasurement as any).checked = true;

        await ViewerActions.createMeasurement(jsonMeasurement as any);
        await ViewerActions.resetDisplayMode();
        
    }
    private _handlePointerObservable = (evt: BABYLON.PointerInfo) => {
        switch (evt.type) {
            case BABYLON.PointerEventTypes.POINTERDOWN:

                //this._pointerMoved = false;
                
                break;
            case BABYLON.PointerEventTypes.POINTERMOVE:

                //this._pointerMoved = true;

                if ((this._measureMode == MeasurementType.Distance ||
                    this._measureMode == MeasurementType.XOrtho ||
                    this._measureMode == MeasurementType.YOrtho ||
                    this._measureMode == MeasurementType.ZOrtho) &&
                    this._currentLine != null) {

                    var canvasRect = this._engine.getRenderingCanvasClientRect();
                    var x = evt.event.clientX - canvasRect.left;
                    var y = evt.event.clientY - canvasRect.top;
                    var screenPoint = new BABYLON.Vector2(x, y);
                    var intersection = this._rayPickProvider.rayPick(screenPoint.x, screenPoint.y);

                    if (intersection.point != null) {
                        var coordinate: ICoordinate = { pointCoordinate: intersection.point, screenCoordinate: screenPoint }

                        if (this._currentLine.measureMode != MeasurementType.Point) {
                            this._currentLine.endPosition = coordinate;
                            this._currentLine.isDirty = true;
                            this._currentLine.valid = this._currentLine.startValid && intersection.valid;
                            this._updateLine(this._currentLine, this.scene.activeCamera);

                            this.scene.render();
                        }
                    }
                }
                
                break;
            case BABYLON.PointerEventTypes.POINTERUP:
                //if (this._pointerMoved)
                //    break;

                
                break;
            case BABYLON.PointerEventTypes.POINTERWHEEL:
                break;
            case BABYLON.PointerEventTypes.POINTERPICK:
                
                break;
            case BABYLON.PointerEventTypes.POINTERTAP:
                break;
            
        }
    }

    public handleTap(clientX: number, clientY: number) {
        if (this._measureMode == MeasurementType.Distance ||
            this._measureMode == MeasurementType.XOrtho ||
            this._measureMode == MeasurementType.YOrtho ||
            this._measureMode == MeasurementType.ZOrtho ||
            this._measureMode == MeasurementType.Point) {

            var canvasRect = this._engine.getRenderingCanvasClientRect();
            var x = clientX - canvasRect.left;
            var y = clientY - canvasRect.top;
            var screenPoint = new BABYLON.Vector2(x, y);
            var intersection = this._rayPickProvider.rayPick(screenPoint.x, screenPoint.y);
            var coordinate: ICoordinate = { pointCoordinate: intersection.point, screenCoordinate: screenPoint }

            if (intersection.point != null) {

                if (this._measureMode == MeasurementType.Distance ||
                    this._measureMode == MeasurementType.XOrtho ||
                    this._measureMode == MeasurementType.YOrtho ||
                    this._measureMode == MeasurementType.ZOrtho) {

                    if (this._currentLine == null) {

                        this._currentLine = { distance: 0, startPosition: coordinate, endPosition: null, text: null, startValid: intersection.valid, valid: false, lines: [], textLine: null, isDirty: true, measureMode: this._measureMode };
                    }
                    else {
                        const finalizedLine = this._currentLine;

                        finalizedLine.endPosition = coordinate;

                        finalizedLine.isDirty = true;
                        finalizedLine.valid = finalizedLine.startValid && intersection.valid;
                        if (!finalizedLine.endPosition || !finalizedLine.valid) {
                            this._disposeLineData(finalizedLine);
                        }
                        else {
                            // Retire the transient placement graphic before the store-driven
                            // measurement is rebuilt in the scene.
                            this._disposeLineData(finalizedLine);
                            this._createMeasurement(finalizedLine);
                        }

                        this._currentLine = null;
                    }
                }
                else if (this._measureMode == MeasurementType.Point && intersection.valid) {

                    var point: IPointMeasurementInfo = { startPosition: coordinate, text: null, startValid: true, valid: true, lines: [], isDirty: true, measureMode: this._measureMode };

                    if (point.startPosition != null) {
                        this._createMeasurement(point as any);
                    }
                }
            }
        }
    }

    /*public handlePointerMove(intersection: {point: BABYLON.Vector3, valid: boolean}, screenPoint: BABYLON.Vector2) {
        if ((this._measureMode == MeasurementType.Distance ||
            this._measureMode == MeasurementType.XOrtho ||
            this._measureMode == MeasurementType.YOrtho ||
            this._measureMode == MeasurementType.ZOrtho) &&
            this._currentLine != null) {

            if (intersection.point != null) {
                var coordinate: ICoordinate = { pointCoordinate: intersection.point, screenCoordinate: screenPoint }

                if (this._currentLine.measureMode != MeasurementType.Point) {
                    this._currentLine.endPosition = coordinate;
                    this._currentLine.isDirty = true;
                    this._currentLine.valid = this._currentLine.startValid && intersection.valid;
                    this._updateLine(this._currentLine, this.scene.activeCamera);
                }
            }
        }
    }

    public handlePointerUp(intersection: {point: BABYLON.Vector3, valid: boolean}, screenPoint: BABYLON.Vector2) {
        if (this._measureMode == MeasurementType.Distance ||
            this._measureMode == MeasurementType.XOrtho ||
            this._measureMode == MeasurementType.YOrtho ||
            this._measureMode == MeasurementType.ZOrtho ||
            this._measureMode == MeasurementType.Point) {

            var canvasRect = this._engine.getRenderingCanvasClientRect();
            //var x = evt.event.clientX - canvasRect.left;
            //var y = evt.event.clientY - canvasRect.top;
            //var screenPoint = new BABYLON.Vector2(x, y);
            //var intersection = this._viewer.pointCloudManager.pickPointCloud(screenPoint, this.scene, .01);
            var coordinate: ICoordinate = { pointCoordinate: intersection.point, screenCoordinate: screenPoint }

            if (intersection.point != null) {

                if (this._measureMode == MeasurementType.Distance ||
                    this._measureMode == MeasurementType.XOrtho ||
                    this._measureMode == MeasurementType.YOrtho ||
                    this._measureMode == MeasurementType.ZOrtho) {

                    if (this._currentLine == null) {

                        this._currentLine = { distance: 0, startPosition: coordinate, endPosition: null, text: null, startValid: intersection.valid, valid: false, lines: [], textLine: null, isDirty: true, measureMode: this._measureMode };
                    }
                    else {
                        this._currentLine.endPosition = coordinate;

                        this._currentLine.isDirty = true;
                        this._currentLine.valid = this._currentLine.startValid && intersection.valid;
                        if (!this._currentLine.endPosition || !this._currentLine.valid) {
                            this._disposeLineData(this._currentLine);
                        }
                        else {
                            this._createMeasurement(this._currentLine);
                        }

                        this._currentLine = null;
                    }
                }
                else if (this._measureMode == MeasurementType.Point && intersection.valid) {

                    var point: IPointMeasurementInfo = { startPosition: coordinate, text: null, startValid: true, valid: true, lines: [], isDirty: true, measureMode: this._measureMode };

                    if (point.startPosition != null) {
                        this._createMeasurement(point as any);
                    }
                }
            }
        }
    }*/

    private _handleBeforeCameraRenderObservable = (camera: BABYLON.Camera) => {

        //(camera as any).rebuildAnglesAndRadius();
        this._measurements.forEach(measurement => {

            this._processGraphicsForMeasurement(measurement, camera);
        });

        if (this._currentLine != null) {
            this._processGraphicsForMeasurement(this._currentLine, camera);
        }
    }

    private _processGraphicsForMeasurement(measurement: IMeasurement, camera: BABYLON.Camera) {
        if (measurement.measureMode != MeasurementType.Point) {

            var line: ILineInfo = measurement as any;
            // Since the positions are based on clicks, we update the positions of the screen so the arrow heads
            // can be correctly drawn.
            if (line.endPosition != null) {
                var endScreen = BABYLON.Vector3.Project(
                    line.endPosition.pointCoordinate,
                    BABYLON.Matrix.Identity(),
                    this.scene.getTransformMatrix(),
                    camera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                );
                line.endPosition.screenCoordinate = new BABYLON.Vector2(endScreen.x, endScreen.y);
            }
            if (line.startPosition != null) {
                var startScreen = BABYLON.Vector3.Project(
                    line.startPosition.pointCoordinate,
                    BABYLON.Matrix.Identity(),
                    this.scene.getTransformMatrix(),
                    camera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                );

                line.startPosition.screenCoordinate = new BABYLON.Vector2(startScreen.x, startScreen.y);
            }

            if (line.startPosition != null && line.endPosition != null) {

                this._updateLine(line, camera);
            }
        }
        else {
            var pointMeasurement: IPointMeasurementInfo = measurement as any;

            if (pointMeasurement.startPosition != null) {
                var startScreen = BABYLON.Vector3.Project(
                    pointMeasurement.startPosition.pointCoordinate,
                    BABYLON.Matrix.Identity(),
                    this.scene.getTransformMatrix(),
                    camera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                );

                pointMeasurement.startPosition.screenCoordinate = new BABYLON.Vector2(startScreen.x, startScreen.y);
            }

            if (pointMeasurement.startPosition != null) {
                var startSeen = camera.isInFrustum(new BABYLON.BoundingInfo(pointMeasurement.startPosition.pointCoordinate, pointMeasurement.startPosition.pointCoordinate));

                if (startSeen)
                    this._updatePointMeasurement(pointMeasurement, startSeen);
            }
        }
    }
   
    private _updatePointMeasurement(point: IPointMeasurementInfo, startSeen: boolean) {

        if (point.startPosition != null) {

            if (point.lines.length > 0) {

                this._guiTexture.removeControl(point.text);
                point.text.dispose();

                for (var lIndex = 0; lIndex < point.lines.length; lIndex++) {
                    this.scene.removeMesh(point.lines[lIndex]);
                    point.lines[lIndex].dispose();
                }

                point.lines = [];
            }

            const p1 = this.scene.createPickingRay(point.startPosition.screenCoordinate.x - 10, point.startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
            const p2 = this.scene.createPickingRay(point.startPosition.screenCoordinate.x + 10, point.startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
            const p3 = this.scene.createPickingRay(point.startPosition.screenCoordinate.x, point.startPosition.screenCoordinate.y - 10, BABYLON.Matrix.Identity(), this.scene.activeCamera);
            const p4 = this.scene.createPickingRay(point.startPosition.screenCoordinate.x, point.startPosition.screenCoordinate.y + 10, BABYLON.Matrix.Identity(), this.scene.activeCamera);
            const tp = this.scene.createPickingRay(point.startPosition.screenCoordinate.x, point.startPosition.screenCoordinate.y -50, BABYLON.Matrix.Identity(), this.scene.activeCamera);

            const t1 = this.scene.createPickingRay(point.startPosition.screenCoordinate.x, point.startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
            var pickLength = t1.origin.subtract(point.startPosition.pointCoordinate).length();

            var pos1 = p1.origin.add(p1.direction.scale(pickLength))
            var pos2 = p2.origin.add(p2.direction.scale(pickLength));
            var pos3 = p3.origin.add(p3.direction.scale(pickLength));
            var pos4 = p4.origin.add(p4.direction.scale(pickLength));
            var textPos = tp.origin.add(tp.direction.scale(pickLength));
            
            var linePoints1 = [pos1, pos2];
            var linePoints2 = [pos3, pos4];

            // Create lines from points
            var acrossLine = BABYLON.MeshBuilder.CreateLines("pointMeasurement", { points: linePoints1, colors: this._validMeasurementColors,  updatable: true }, this.scene);
            var downLine = BABYLON.MeshBuilder.CreateLines("pointMeasurement", { points: linePoints2, colors: this._validMeasurementColors, updatable: true }, this.scene);
            acrossLine.renderingGroupId = 1;
            acrossLine.isPickable = false;
            
            downLine.renderingGroupId = 1;
            downLine.isPickable = false;

            var text = new BABYLONGUI.TextBlock("PointText", "");
            text.color = this._validColor.toHexString();
            text.resizeToFit = true;
            text.text = "N " + ViewerStore.convertToUserUnit(point.startPosition.pointCoordinate.z) + "\n" +
                "W " + ViewerStore.convertToUserUnit(point.startPosition.pointCoordinate.x) + "\n" +
                "U " + ViewerStore.convertToUserUnit(point.startPosition.pointCoordinate.y);
            this._guiTexture.addControl(text);

            point.text = text;
            var topPoint = BABYLON.Mesh.CreateSphere("textPoint", 1, 1);
            topPoint.position = textPos;
            topPoint.setEnabled(false);
            text.linkWithMesh(topPoint);

            point.lines.push(acrossLine);
            point.lines.push(downLine);
        }
    }

    private _updateLine(line: ILineInfo, camera: BABYLON.Camera) {

        var orthoMode = line.measureMode;
        {

            if (line.startPosition != null && line.endPosition != null) {


                // check if measurement is valid. If it is not, draw ortho measurement as noraml red line
                var pointsValid = line.startPosition && line.endPosition;

                // draw lines
                if (orthoMode == MeasurementType.Distance || !pointsValid) {

                    var startPosition = line.startPosition;
                    var endPosition = line.endPosition;

                    var startSeen = camera.isInFrustum(new BABYLON.BoundingInfo(line.startPosition.pointCoordinate, line.startPosition.pointCoordinate));
                    var endSeen = camera.isInFrustum(new BABYLON.BoundingInfo(line.endPosition.pointCoordinate, line.endPosition.pointCoordinate));

                    var dir = new BABYLON.Vector2(endPosition.screenCoordinate.x - startPosition.screenCoordinate.x, endPosition.screenCoordinate.y - startPosition.screenCoordinate.y);

                    if (dir.length() > 0) {

                        var length = Math.min(15, dir.length() * .5);
                        dir.normalize();
                        dir = dir.scale(length);

                        var flipStartHead = false;
                        var flipEndHead = false;
                        var rot1 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, Math.PI / 6);
                        var rot2 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, -1 * Math.PI / 6);
                        var rot3 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, Math.PI / 6);
                        var rot4 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, -1 * Math.PI / 6);

                        var flipStartHead = true;
                        var flipEndHead = true;

                        var rot1f = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, Math.PI / 6);
                        var rot2f = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, -1 * Math.PI / 6);
                        var rot3f = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, Math.PI / 6);
                        var rot4f = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, -1 * Math.PI / 6);

                        const p1 = this.scene.createPickingRay(rot1.x, rot1.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p2 = this.scene.createPickingRay(rot2.x, rot2.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p3 = this.scene.createPickingRay(rot3.x, rot3.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p4 = this.scene.createPickingRay(rot4.x, rot4.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);

                        const p1f = this.scene.createPickingRay(rot1f.x, rot1f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p2f = this.scene.createPickingRay(rot2f.x, rot2f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p3f = this.scene.createPickingRay(rot3f.x, rot3f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const p4f = this.scene.createPickingRay(rot4f.x, rot4f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);

                        const t1 = this.scene.createPickingRay(startPosition.screenCoordinate.x, startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        var pickLength = t1.origin.subtract(startPosition.pointCoordinate).length();

                        var pos1 = p1.origin.add(p1.direction.scale(pickLength))
                        var pos2 = p2.origin.add(p2.direction.scale(pickLength));
                        var pos3 = p3.origin.add(p3.direction.scale(pickLength));
                        var pos4 = p4.origin.add(p4.direction.scale(pickLength));

                        var pos1f = p1f.origin.add(p1f.direction.scale(pickLength))
                        var pos2f = p2f.origin.add(p2f.direction.scale(pickLength));
                        var pos3f = p3f.origin.add(p3f.direction.scale(pickLength));
                        var pos4f = p4f.origin.add(p4f.direction.scale(pickLength));

                        if (endPosition.pointCoordinate.subtract(pos1f).length() < endPosition.pointCoordinate.subtract(pos1).length()) {
                            pos1 = pos1f;
                            pos2 = pos2f;
                        }

                        if (startPosition.pointCoordinate.subtract(pos3f).length() < startPosition.pointCoordinate.subtract(pos3).length()) {
                            pos3 = pos3f;
                            pos4 = pos4f;
                        }

                        var centerPoint = startPosition.pointCoordinate.add(endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).scale(.5));

                        var linePoints;
                        var textLinePoints;
                        if (startSeen && endSeen) {
                            linePoints = [pos1.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), pos2.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos3.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos4.subtract(centerPoint)];
                        }
                        else if (startSeen) {
                            linePoints = [pos1.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), pos2.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];
                        }
                        else if (endSeen) {
                            linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos3.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos4.subtract(centerPoint)];
                        }
                        else {
                            linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];
                        }

                        // We need to project the points so that they are coplanar with respect
                        // to the direction of the camera's plane. Otherwise, the text
                        // does not appear in the middle of the line. This is because we are now
                        // in actual world coordinates, and not in a dome with a fixed
                        // distance of the image coordinates.
                        const textP1 = this.scene.createPickingRay(startPosition.screenCoordinate.x, startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                        const textP2 = this.scene.createPickingRay(endPosition.screenCoordinate.x, endPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                    
                        var textFinalPos1 = textP1.origin.add(textP1.direction.scale(pickLength))
                        var textFinalPos2 = textP2.origin.add(textP2.direction.scale(pickLength));
                        var testCenterPos = textFinalPos1.add(textFinalPos2.subtract(textFinalPos1).scale(.5));
                        
                        textLinePoints = [textFinalPos1.subtract(testCenterPos), textFinalPos2.subtract(testCenterPos)];

                        if (line.lines.length > 0) {

                            this.scene.removeMesh(line.textLine);
                            this._guiTexture.removeControl(line.text);
                            line.textLine.dispose();

                            for (var lIndex = 0; lIndex < line.lines.length; lIndex++) {
                                this.scene.removeMesh(line.lines[lIndex]);
                                line.text.dispose();
                                line.lines[lIndex].dispose();
                            }

                            line.lines = [];
                        }

                        line.lines.push(BABYLON.MeshBuilder.CreateLines("line", {
                            colors: line.valid ? this._validMeasurementColors : this._invalidMeasurementColors,
                            points: linePoints,
                            updatable: true
                        }, this.scene));

                        if (line != this._currentLine) {
                            const distanceHead1 = BABYLON.Vector3.Distance(camera.position, line.startPosition.pointCoordinate);
                            const distanceHead2 = BABYLON.Vector3.Distance(camera.position, line.endPosition.pointCoordinate);
                            const fov = camera.fov; // Field of view in radians
                            const viewportHeight = this.scene.getEngine().getRenderHeight(); // Viewport height in pixels
                            const cameraDistanceToScreen = 1 / Math.tan(fov / 2); // How far the camera "sees"
                            const scaleFactorHead1 = (distanceHead1 / cameraDistanceToScreen) * (2 / viewportHeight);
                            const scaleFactorHead2 = (distanceHead2 / cameraDistanceToScreen) * (2 / viewportHeight);

                            var sphere1 = BABYLON.MeshBuilder.CreateSphere("startPointSphere", {
                                diameter: 7,
                            }, this.scene);

                            var sphere2 = BABYLON.MeshBuilder.CreateSphere("startPointSphere", {
                                diameter: 7,
                            }, this.scene);

                            sphere1.scaling = new BABYLON.Vector3(scaleFactorHead1, scaleFactorHead1, scaleFactorHead1);
                            sphere2.scaling = new BABYLON.Vector3(scaleFactorHead2, scaleFactorHead2, scaleFactorHead2);

                            sphere1.position = line.startPosition.pointCoordinate;
                            sphere2.position = line.endPosition.pointCoordinate;

                            sphere1.isPickable = false;
                            sphere2.isPickable = false;

                            sphere1.material = this._sphereMeasurementMaterial;
                            sphere2.material = this._sphereMeasurementMaterial;

                            //sphere1.renderingGroupId = 1;
                            //sphere2.renderingGroupId = 1;

                            line.lines.push(sphere1);
                            line.lines.push(sphere2);
                        }

                        // Yes, this is silly. We create a second disabled line for the text. WHy don't we use the line above to link to the mesh?
                        // This is done because there are nasty bugs when the line has hidden points, and we handle the head drawing. The position on
                        // which the text gets anchored is off in that case. Therefore, we create a dummy 2 point line for the text.
                        line.textLine = BABYLON.MeshBuilder.CreateLines("textline", {
                            points: textLinePoints,
                            updatable: true
                        }, this.scene);

                        line.textLine.setEnabled(false);

                        var textSeen = camera.isInFrustum(new BABYLON.BoundingInfo(centerPoint, centerPoint));
                        var text = new BABYLONGUI.TextBlock("text", "");
                        text.color = this._validColor.toHexString();
                        text.resizeToFit = true;
                        text.text = "Text";
                        
                        this._guiTexture.addControl(text);

                        text.isPointerBlocker = false;
                        line.text = text as any;
                        line.lines[0].isPickable = false;

                        line.text.linkWithMesh(line.textLine);

                        line.lines[0].renderingGroupId = 1;
                        line.lines[0].position = centerPoint;
                        line.textLine.position = testCenterPos;
                        var distance = (line.valid) ? endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).length() : 0;

                        var textDistance = (line.valid) ? endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).length() * 1000 : 0;
                        (line as any).distance = distance;
                        var flip = startPosition.screenCoordinate.x > endPosition.screenCoordinate.x;
                        var text: BABYLONGUI.TextBlock = line.text as BABYLONGUI.TextBlock;
                        var dir = new BABYLON.Vector2(endPosition.screenCoordinate.y - startPosition.screenCoordinate.y, endPosition.screenCoordinate.x - startPosition.screenCoordinate.x);

                        text.rotation = Math.atan2(dir.x, dir.y);
                        dir = dir.normalize();

                        text.linkOffsetX = dir.x * 10;
                        text.linkOffsetY = dir.y * 10 * -1;

                        if (flip) {
                            text.rotation += Math.PI;
                            text.linkOffsetX = dir.x * 10 * -1;
                            text.linkOffsetY = dir.y * 10;
                        }

                        text.text = line.valid && textSeen ? ViewerStore.convertToUserUnit(distance) : "";
                    }
                    else {
                        line.valid = false;
                    }
                }
                else {

                    var pA;

                    if (orthoMode == MeasurementType.XOrtho) {
                        pA = new BABYLON.Vector3(line.endPosition.pointCoordinate.x, line.startPosition.pointCoordinate.y, line.startPosition.pointCoordinate.z);
                    }
                    else if (orthoMode == MeasurementType.YOrtho) {
                        pA = new BABYLON.Vector3(line.startPosition.pointCoordinate.x, line.endPosition.pointCoordinate.y, line.startPosition.pointCoordinate.z);
                    }
                    else if (orthoMode == MeasurementType.ZOrtho) {
                        pA = new BABYLON.Vector3(line.startPosition.pointCoordinate.x, line.startPosition.pointCoordinate.y, line.endPosition.pointCoordinate.z);
                    }

                    var aScreen = BABYLON.Vector3.Project(
                        pA,
                        BABYLON.Matrix.Identity(),
                        this.scene.getTransformMatrix(),
                        this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                    );

                    var pointA = { pointCoordinate: pA, screenCoordinate: new BABYLON.Vector2(aScreen.x, aScreen.y) };

                    var pB;
                    if (orthoMode == MeasurementType.XOrtho) {
                        pB = new BABYLON.Vector3(line.endPosition.pointCoordinate.x, line.endPosition.pointCoordinate.y, line.startPosition.pointCoordinate.z);
                    }
                    else if (orthoMode == MeasurementType.YOrtho) {
                        pB = new BABYLON.Vector3(line.endPosition.pointCoordinate.x, line.endPosition.pointCoordinate.y, line.startPosition.pointCoordinate.z);
                    }
                    else if (orthoMode == MeasurementType.ZOrtho) {
                        pB = new BABYLON.Vector3(line.endPosition.pointCoordinate.x, line.startPosition.pointCoordinate.y, line.endPosition.pointCoordinate.z);
                    }

                    var bScreen = BABYLON.Vector3.Project(
                        pB,
                        BABYLON.Matrix.Identity(),
                        this.scene.getTransformMatrix(),
                        this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                    );
                    
                    var pointB = { pointCoordinate: pB, screenCoordinate: new BABYLON.Vector2(bScreen.x, bScreen.y) };

                    var startSeen = camera.isInFrustum(new BABYLON.BoundingInfo(line.startPosition.pointCoordinate, line.startPosition.pointCoordinate));
                    var endSeen = camera.isInFrustum(new BABYLON.BoundingInfo(pointA.pointCoordinate, pointA.pointCoordinate));

                    {
                        const startPosition = line.startPosition;
                        const endPosition = pointA;

                        var dir = new BABYLON.Vector2(endPosition.screenCoordinate.x - startPosition.screenCoordinate.x, endPosition.screenCoordinate.y - startPosition.screenCoordinate.y);

                        if (dir.length() > 0) {

                            var length = Math.min(15, dir.length() * .5);
                            dir.normalize();
                            dir = dir.scale(length);

                            var centerPoint = startPosition.pointCoordinate.add(endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).scale(.5));

                            
                            var linePoints;
                            var textLinePoints;

                            linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];

                            var flipStartHead = false;
                            var flipEndHead = false;
                            var rot1 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, Math.PI / 6);
                            var rot2 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, -1 * Math.PI / 6);
                            var rot3 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, Math.PI / 6);
                            var rot4 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, -1 * Math.PI / 6);

                            var flipStartHead = true;
                            var flipEndHead = true;

                            var rot1f = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, Math.PI / 6);
                            var rot2f = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, -1 * Math.PI / 6);
                            var rot3f = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, Math.PI / 6);
                            var rot4f = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, -1 * Math.PI / 6);

                            const p1 = this.scene.createPickingRay(rot1.x, rot1.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p2 = this.scene.createPickingRay(rot2.x, rot2.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p3 = this.scene.createPickingRay(rot3.x, rot3.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p4 = this.scene.createPickingRay(rot4.x, rot4.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);

                            const p1f = this.scene.createPickingRay(rot1f.x, rot1f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p2f = this.scene.createPickingRay(rot2f.x, rot2f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p3f = this.scene.createPickingRay(rot3f.x, rot3f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            const p4f = this.scene.createPickingRay(rot4f.x, rot4f.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);

                            const t1 = this.scene.createPickingRay(startPosition.screenCoordinate.x, startPosition.screenCoordinate.y, BABYLON.Matrix.Identity(), this.scene.activeCamera);
                            var pickLength = t1.origin.subtract(startPosition.pointCoordinate).length();

                            var pos1 = p1.origin.add(p1.direction.scale(pickLength))
                            var pos2 = p2.origin.add(p2.direction.scale(pickLength));
                            var pos3 = p3.origin.add(p3.direction.scale(pickLength));
                            var pos4 = p4.origin.add(p4.direction.scale(pickLength));

                            var pos1f = p1f.origin.add(p1f.direction.scale(pickLength))
                            var pos2f = p2f.origin.add(p2f.direction.scale(pickLength));
                            var pos3f = p3f.origin.add(p3f.direction.scale(pickLength));
                            var pos4f = p4f.origin.add(p4f.direction.scale(pickLength));

                            if (endPosition.pointCoordinate.subtract(pos1f).length() < endPosition.pointCoordinate.subtract(pos1).length()) {
                                pos1 = pos1f;
                                pos2 = pos2f;
                            }

                            if (startPosition.pointCoordinate.subtract(pos3f).length() < startPosition.pointCoordinate.subtract(pos3).length()) {
                                pos3 = pos3f;
                                pos4 = pos4f;
                            }

                            var linePoints;
                            var textLinePoints;
                            if (startSeen && endSeen) {
                                linePoints = [pos1.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), pos2.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos3.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos4.subtract(centerPoint)];
                            }
                            else if (startSeen) {
                                linePoints = [pos1.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), pos2.subtract(centerPoint), startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];
                            }
                            else if (endSeen) {
                                linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos3.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint), pos4.subtract(centerPoint)];
                            }
                            else {
                                linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];
                            }


                            textLinePoints = [startPosition.pointCoordinate, endPosition.pointCoordinate];
                            
                            if (line.lines.length > 0) {

                                this.scene.removeMesh(line.textLine);
                                this._guiTexture.removeControl(line.text);
                                line.textLine.dispose();

                                for (var lIndex = 0; lIndex < line.lines.length; lIndex++) {
                                    this.scene.removeMesh(line.lines[lIndex]);
                                    line.text.dispose();
                                    line.lines[lIndex].dispose();
                                }

                                line.lines = [];
                            }

                            var orthoLine = (BABYLON.MeshBuilder.CreateLines("line", {
                                colors: line.valid ? this._validMeasurementColors : this._invalidMeasurementColors,
                                points: linePoints,
                                updatable: true
                            }, this.scene));

                            orthoLine.renderingGroupId = 1;
                            orthoLine.isPickable = false;
                            orthoLine.position = centerPoint;
                            line.lines.push(orthoLine);

                            // Yes, this is silly. We create a second disabled line for the text. WHy don't we use the line above to link to the mesh?
                            // This is done because there are nasty bugs when the line has hidden points, and we handle the head drawing. The position on
                            // which the text gets anchored is off in that case. Therefore, we create a dummy 2 point line for the text.
                            line.textLine = BABYLON.MeshBuilder.CreateLines("textline", {
                                points: textLinePoints,
                                //colors: line.valid ? this._validMeasurementColors : this._invalidMeasurementColors,
                                updatable: true
                            }, this.scene);

                            line.textLine.setEnabled(false);

                            if (line != this._currentLine) {
                                const distanceHead1 = BABYLON.Vector3.Distance(camera.position, line.startPosition.pointCoordinate);
                                const distanceHead2 = BABYLON.Vector3.Distance(camera.position, line.endPosition.pointCoordinate);
                                const fov = camera.fov; // Field of view in radians
                                const viewportHeight = this.scene.getEngine().getRenderHeight(); // Viewport height in pixels
                                const cameraDistanceToScreen = 1 / Math.tan(fov / 2); // How far the camera "sees"
                                const scaleFactorHead1 = (distanceHead1 / cameraDistanceToScreen) * (2 / viewportHeight);
                                const scaleFactorHead2 = (distanceHead2 / cameraDistanceToScreen) * (2 / viewportHeight);

                                var sphere1 = BABYLON.MeshBuilder.CreateSphere("startPointSphere", {
                                    diameter: 7,
                                }, this.scene);

                                var sphere2 = BABYLON.MeshBuilder.CreateSphere("startPointSphere", {
                                    diameter: 7,
                                }, this.scene);

                                sphere1.scaling = new BABYLON.Vector3(scaleFactorHead1, scaleFactorHead1, scaleFactorHead1);
                                sphere2.scaling = new BABYLON.Vector3(scaleFactorHead2, scaleFactorHead2, scaleFactorHead2);

                                sphere1.position = line.startPosition.pointCoordinate;
                                sphere2.position = line.endPosition.pointCoordinate;

                                sphere1.isPickable = false;
                                sphere2.isPickable = false;

                                sphere1.material = this._sphereMeasurementMaterial;
                                sphere2.material = this._sphereMeasurementMaterial;

                                //sphere1.renderingGroupId = 1;
                                //sphere2.renderingGroupId = 1;

                                line.lines.push(sphere1);
                                line.lines.push(sphere2);
                            }
                            
                            var text = new BABYLONGUI.TextBlock("text", "");
                            text.color = this._validColor.toHexString();
                            text.resizeToFit = true;
                            text.text = "Text";
                            this._guiTexture.addControl(text);

                            text.isPointerBlocker = false;
                            line.text = text as any;
                            line.lines[0].isPickable = false;

                            line.text.linkWithMesh(line.textLine);

                            const distance = (line.valid) ? endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).length() : 0;
                            
                            (line as any).distance = distance;
                            var flip = startPosition.screenCoordinate.x > endPosition.screenCoordinate.x;
                            var text: BABYLONGUI.TextBlock = line.text as BABYLONGUI.TextBlock;

                            var text1Screen = BABYLON.Vector3.Project(
                                textLinePoints[0],
                                BABYLON.Matrix.Identity(),
                                this.scene.getTransformMatrix(),
                                this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                            );

                            var text2Screen = BABYLON.Vector3.Project(
                                textLinePoints[1],
                                BABYLON.Matrix.Identity(),
                                this.scene.getTransformMatrix(),
                                this.scene.activeCamera.viewport.toGlobal(this.engine.getRenderWidth(), this.engine.getRenderHeight())
                            );
                            var dir = new BABYLON.Vector2(text2Screen.y - text1Screen.y, text2Screen.x - text1Screen.x);

                            text.rotation = Math.atan2(dir.x, dir.y);
                            dir = dir.normalize();

                            text.linkOffsetX = dir.x * 10;
                            text.linkOffsetY = dir.y * 10 * -1;

                            if (flip) {
                                text.rotation += Math.PI;
                                text.linkOffsetX = dir.x * 10 * -1;
                                text.linkOffsetY = dir.y * 10;
                            }

                            text.text = line.valid ? ViewerStore.convertToUserUnit(distance) : "";
                        }
                        else {
                            line.valid = false;
                        }
                    }
                    if (line.valid) {
                        {
                            const startPosition = pointA;
                            const endPosition = pointB;

                            var dir = new BABYLON.Vector2(endPosition.screenCoordinate.x - startPosition.screenCoordinate.x, endPosition.screenCoordinate.y - startPosition.screenCoordinate.y);
                            var numDashes = Math.max(2, dir.length() / 10);
                            if (dir.length() > 0) {

                                //line.valid = startPosition.pointCoordinate && endPosition.pointCoordinate ? true : false;

                                var length = Math.min(15, dir.length() * .5);
                                dir.normalize();
                                dir = dir.scale(length);

                                const centerPoint = startPosition.pointCoordinate.add(endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).scale(.5));

                                var linePoints;
                                var textLinePoints;

                                linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];

                                var dotLine = (BABYLON.MeshBuilder.CreateDashedLines("line", {
                                    points: linePoints,
                                    updatable: true,
                                    dashNb: numDashes

                                }, this.scene));

                                if (line != this._currentLine) {
                                    dotLine.color = this._validColor;
                                }

                                dotLine.isPickable = false;
                                dotLine.renderingGroupId = 1;
                                dotLine.position = centerPoint;

                                line.lines.push(dotLine);
                            }
                            else {
                                line.valid = false;
                            }
                        }
                        {
                            const startPosition = pointB;
                            const endPosition = line.endPosition;

                            var dir = new BABYLON.Vector2(endPosition.screenCoordinate.x - startPosition.screenCoordinate.x, endPosition.screenCoordinate.y - startPosition.screenCoordinate.y);
                            var numDashes = Math.max(2, dir.length() / 10);
                            if (dir.length() > 0) {

                                var length = Math.min(15, dir.length() * .5);
                                dir.normalize();
                                dir = dir.scale(length);

                                var flipStartHead = startSeen && !endSeen ? this.scene.pick(endPosition.screenCoordinate.x, endPosition.screenCoordinate.y).pickedPoint?.subtract(endPosition.pointCoordinate).length() > 1 : false;
                                var flipEndHead = !startSeen && endSeen ? this.scene.pick(startPosition.screenCoordinate.x, startPosition.screenCoordinate.y).pickedPoint?.subtract(startPosition.pointCoordinate).length() > 1 : false;

                                var rot1 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, Math.PI / 6);
                                var rot2 = this._rotatePoint(startPosition.screenCoordinate.add(!flipStartHead ? dir : dir.scale(-1)), startPosition.screenCoordinate, -1 * Math.PI / 6);
                                var rot3 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, Math.PI / 6);
                                var rot4 = this._rotatePoint(endPosition.screenCoordinate.add(!flipEndHead ? dir.scale(-1) : dir), endPosition.screenCoordinate, -1 * Math.PI / 6);

                                const centerPoint = startPosition.pointCoordinate.add(endPosition.pointCoordinate.subtract(startPosition.pointCoordinate).scale(.5));

                                var linePoints;
                                var textLinePoints;

                                linePoints = [startPosition.pointCoordinate.subtract(centerPoint), endPosition.pointCoordinate.subtract(centerPoint)];

                                var dotLine = (BABYLON.MeshBuilder.CreateDashedLines("line", {
                                    points: linePoints,
                                    updatable: true,
                                    dashNb: numDashes

                                }, this.scene));

                                if (line != this._currentLine) {
                                    dotLine.color = this._validColor;
                                }

                                dotLine.isPickable = false;
                                dotLine.renderingGroupId = 1;
                                dotLine.position = centerPoint;

                                line.lines.push(dotLine);
                            }
                            else {
                                line.valid = false;
                            }
                        }
                    }
                }
            }
            else {
                this._disposeLineData(line);
            }

            line.isDirty = false;
        }
    }

    private _rotatePoint(point: BABYLON.Vector2, center: BABYLON.Vector2, angle: number): BABYLON.Vector2 {
        const x = center.x + (point.x - center.x) * Math.cos(angle) - (point.y - center.y) * Math.sin(angle);
        const y = center.y + (point.x - center.x) * Math.sin(angle) + (point.y - center.y) * Math.cos(angle);
        return new BABYLON.Vector2(x, y);
    }
    private _disposeMeasurement(measuremnt: IMeasurement) {
        if (measuremnt.measureMode != MeasurementType.Point) {
            const line = measuremnt as ILineInfo;
            if (line.text) {
                this._guiTexture.removeControl(line.text);
            }
            if (line.textLine) {
                this.scene.removeMesh(line.textLine);
                line.textLine.dispose();
                line.textLine = null;
            }
        } else if (measuremnt.text) {
            this._guiTexture.removeControl(measuremnt.text);
        }

        for (var x = 0; x < measuremnt.lines.length; x++) {
            measuremnt.lines[x].dispose();
        }
        measuremnt.text?.dispose();
        measuremnt.text = null;
        measuremnt.lines = [];
    }

    private _disposePointMeasurement(pointMeasurement: IPointMeasurementInfo) {

        if (pointMeasurement.text) {
            this._guiTexture.removeControl(pointMeasurement.text);
        }
        pointMeasurement.text?.dispose();
        pointMeasurement.text = null;
    }

    private _disposeLineData(line: ILineInfo) {

        if (line.text) {
            this._guiTexture.removeControl(line.text);
        }
        if (line.textLine) {
            this.scene.removeMesh(line.textLine);
            line.textLine.dispose();
            line.textLine = null;
        }

        for (var x = 0; x < line.lines.length; x++) {
            line.lines[x].dispose();
        }
        line.text?.dispose();
        line.text = null;
        line.lines = [];
    }
}

export default MeasurementManager;